export default __webpack_public_path__ + "static/media/BA4.a4d4265b.jpg";